// Presentation-only verified administrator badge (exact asset supplied by user).
// Audit records always keep the real reviewer name as text; this is decoration only.
export const VerifiedBadge = ({ size = 13, className = "", title = "Verified administrator" }) => (
  <img
    src="/verified-badge.png"
    alt="Verified"
    title={title}
    data-testid="verified-badge"
    style={{ width: size, height: size }}
    className={`inline-block shrink-0 align-middle ${className}`}
  />
);

export default VerifiedBadge;
